export const SAVE = 'step15.SAVE';
export const VALUE_CHANGED = 'step15.VALUE_CHANGED';
export const LOAD = 'step15.VALUE_LOAD';
export const RESET = 'step15.RESET';
export const RESET_GIVE_PERMISSION_STATE = 'step15.RESET_GIVE_PERMISSION_STATE';
export const SET_DEFAULT_VALUE = 'step15.SET_DEFAULT_VALUE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step15/constants.js